/** @format */
export const ProductRecommendationsPageType = {
	CART_SUCCESS: 'CartSuccess',
	CART: 'Cart',
	ORDER_CONFIRMATION: 'OrderConfirmation',
	ORDER_DETAILS: 'OrderDetails',
	PDP: 'PDP',
	FAVORITES: 'Favorites'
};
